import 'leaflet-routing-machine/dist/leaflet-routing-machine.css'
import L from 'leaflet'
import 'leaflet-rotatedmarker'
import 'leaflet-routing-machine'
import {useEffect} from 'react'
import {useMap} from 'react-leaflet'

export const degToRad = (degrees) => {
  return (degrees * Math.PI) / 180
}

export const radToDeg = (radians) => {
  return (radians * 180) / Math.PI
}

export const getBearing = (pointA, pointB) => {
  const lat1 = degToRad(pointA.lat)
  const lat2 = degToRad(pointB.lat)
  const lonDiff = degToRad(pointB.long - pointA.long)

  const y = Math.sin(lonDiff) * Math.cos(lat2)
  const x =
    Math.cos(lat1) * Math.sin(lat2) -
    Math.sin(lat1) * Math.cos(lat2) * Math.cos(lonDiff)
  let brng = radToDeg(Math.atan2(y, x))

  // Normalize the bearing to a positive value between 0 and 360 degrees
  brng = (brng + 360) % 360
  return brng
}
export const CreateLeafIcon = ({url}) => {
  return L.icon({
    iconUrl: url,
  })
}

export const RoutingAdd = ({waypoints}) => {
  const map = useMap()
  useEffect(() => {
    if (!map) return
    const routingControl = L.Routing.control({
      waypoints: waypoints.map(({lat, long}) => L.latLng(lat, long)),
      show: false,
      addWaypoints: false,
      draggableWaypoints: false,
      lineOptions: {styles: [{color: '#5932EA', opacity: 1, weight: 5}]},
      router: new L.Routing.osrmv1({
        language: 'id',
        profile: 'car',
      }),
    }).addTo(map)

    return () => map.removeControl(routingControl)
  }, [map, waypoints])

  return null
}
